import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { EmailapiComponent } from './emailapi/emailapi.component';
import { LiveapiComponent } from './liveapi/liveapi.component';
import { DocumentsapiComponent } from './documentsapi/documentsapi.component';
import { ReviewsapiComponent } from './reviewsapi/reviewsapi.component';
import { PhotosapiComponent } from './photosapi/photosapi.component';
import { WidgetHomeComponent } from './widgets/widget-home/widget-home.component';


const routes: Routes = [
  { path: '', component: HomeComponent },
  {
      path: '',
      children: [
          { path: 'home', component: HomeComponent },
          { path: 'emailapi', component: EmailapiComponent },
          { path: 'liveapi', component: LiveapiComponent},
          { path: 'documentsapi', component: DocumentsapiComponent},
          { path: 'reviewsapi', component: ReviewsapiComponent},
          { path: 'photosapi', component: PhotosapiComponent },
          { path: 'widgets', component: WidgetHomeComponent }
      ]
  },
  { path: '**', redirectTo: '', pathMatch: 'full'}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
